import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  Row,
  Col,
  Grid,
  Input,
  ControlLabel,
  SelectPicker,
} from 'rsuite'
import AppContext from '../../context/AppContext'
import './styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { budgetFormat } from '../../utils/formatterUtil'
import { useCookies } from 'react-cookie'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function TableSubProject({
  schema,
  subName,
  single,
  onSingleSubmit = () => {},
  muti,
  onMutiSubmit,
  enableView,
  onView,
  onRemove,
  onReload,
  pagination,
  lengthMenu,
  loading,
  hiddenColStatus,
  searchRows,
  onSearchProject,
  onSelectProject,
  Controller,
  control,
  onShow,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  // const history = useHistory()
  // const [selectList, setSelectList] = useState([])
  // const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  // const contextValue = React.useContext(AppContext)
  const [tableData, setTableData] = useState([])
  const [inputValueCode, setInputValueCode] = useState('')
  const [inputValueName, setInputValueName] = useState('')
  const [inputValueYear, setInputValueYear] = useState('')
  const [expand, setExpand] = useState(true)
  const [cookies, setCookie] = useCookies(['projectforsub_cookie'])

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.values) {
      setTableData(schema.values)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1, inputValueCode, inputValueName, inputValueYear)
    }
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey, inputValueCode, inputValueName, inputValueYear)
    }
  }

  const getData = () => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangeProjectCode = (val) => {
    setInputValueCode(val)
  }

  const handleChangeProjectName = (val) => {
    setInputValueName(val)
  }

  const handleSearchProject = () => {
    onSearchProject(5, 1, inputValueCode, inputValueName, inputValueYear)
    setPage(1)
  }

  const handleCancelSearchProject = () => {
    setInputValueCode('')
    setInputValueName('')
    setInputValueYear('')
    onSearchProject(5, 1, '', '', '')
    setPage(1)
  }

  return (
    <>
      <Panel
        header={schema?.header}
        bordered
        collapsible={onShow}
        // shaded
        defaultExpanded
        expanded={cookies.projectforsub_cookie ? false : expand}
        className="table-all-project"
        // onClick={collapsiblePanel}
      >
        {searchRows?.enable && (
          <Grid fluid>
            <Row gutter={16}>
              <Col lg={6} md={6} sm={24} xs={24}>
                <ControlLabel>{schema?.searchRows?.projectCodeLabel}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={'projectcode'}
                  value={inputValueCode}
                  placeholder={`ระบุ${schema?.searchRows?.projectCodeLabel}`}
                  onChange={handleChangeProjectCode}
                ></Input>
              </Col>
              <Col lg={6} md={6} sm={24} xs={24}>
                <ControlLabel>{schema?.searchRows?.projectNameLabel}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={'projectname'}
                  value={inputValueName}
                  placeholder={`ระบุ${schema?.searchRows?.projectNameLabel}`}
                  onChange={handleChangeProjectName}
                ></Input>
              </Col>
              <Col lg={6} md={6} sm={24} xs={24}>
                <ControlLabel>{schema?.searchRows?.projectYearOption?.label}</ControlLabel>
                <Controller
                  key={'projectyear'}
                  name={'projectyear'}
                  control={control}
                  render={(props) => {
                    return (
                      <SelectPicker
                        style={{ width: '100%' }}
                        searchable={false}
                        defaultValue={''}
                        value={inputValueYear}
                        data={schema?.searchRows?.projectYearOption?.options}
                        onChange={(value) => {
                          console.log('value => ', value)
                          setInputValueYear(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={6} md={6} sm={24} xs={24}>
                <div>
                  <br />
                  <SearchButton
                    style={{ minWidth: '40%', height: '35px' }}
                    children={schema?.searchRows?.buttonSearchText}
                    onClick={handleSearchProject}
                  />
                  &nbsp;&nbsp;&nbsp;
                  <CancelButton
                    style={{ minWidth: '40%', height: '35px' }}
                    children={schema?.searchRows?.buttonCancelText}
                    onClick={handleCancelSearchProject}
                  />
                </div>
              </Col>
            </Row>
            {/* </Form> */}
          </Grid>
        )}

        <Table
          wordWrap
          height={400}
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
        >
          <Column align="center" width={200} fixed>
            <HeaderCell>
              <span>{schema?.projectCodeText}</span>
            </HeaderCell>
            <Cell dataKey="code" />
          </Column>

          <Column width={470} minWidth={470} flexGrow={1}>
            <HeaderCell>
              <span>{schema?.projectNameText}</span>
            </HeaderCell>
            <Cell dataKey="projectName" />
          </Column>

          <Column width={220} align="right">
            <HeaderCell>
              <span>{schema?.projectBudgetText}</span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.projectBudget)
              }}
            </Cell>
          </Column>

          <Column width={160} align="right">
            <HeaderCell>
              <span>{schema?.countSubProjectText}</span>
            </HeaderCell>
            <Cell dataKey="countSubProject" />
          </Column>

          <Column width={220} align="right">
            <HeaderCell>
              <span>{schema?.budgetForSubProjectText}</span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.budgetForSubProject)
              }}
            </Cell>
          </Column>

          <Column width={150} align="center" fixed="right">
            <HeaderCell>
              <span></span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <IconButton
                    appearance="ghost"
                    icon={
                      <Icon icon={schema?.single?.singleIcon} className="bt-gost-icon-radius" />
                    }
                    onClick={() => {
                      setExpand(false)
                      onSelectProject(rowData?.projectVersionId, rowData.budgetForSubProject)
                    }}
                  >
                    {schema?.single?.buttonText + '/แก้ไข'}
                  </IconButton>
                )
              }}
            </Cell>
          </Column>
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={lengthMenu || defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema?.totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}

        {schema?.message && (
          <Row>
            <Message showIcon type={schema?.message?.type} description={schema?.message?.message} />
          </Row>
        )}

        <ConfirmWidget
          title={`ยืนยันการลบรายการ`}
          show={isShowConfirm}
          detail={`ยืนยันการลบ ${
            deleteObj?.projectName ? schema?.projectNameText + ' : ' + deleteObj?.projectName : ''
          }`}
          onCancle={() => {
            setIsShowConfirm(false)
            setDeleteObj({})
          }}
          onConfirm={() => {
            onRemove(deleteObj)
            let total = schema?.values?.length || 0
            let newPage = Math.ceil(total / displayLength)
            if (newPage > 0 && newPage < page) {
              setPage(newPage)
            }
            setIsShowConfirm(false)
          }}
        />
      </Panel>
    </>
  )
}
